import React, { ReactNode } from "react";
import { Box, Button, styled } from "@mui/material";
import { BackArrowIcon } from "./icons/BackArrowIcon";

interface HeaderProps {
  onExit: () => void;
  centerContent?: ReactNode;
  headerActions?: ReactNode;
}

const HeaderContainer = styled(Box, {
  label: "MSHatHeaderContainer",
})(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  height: 64,
  padding: "0 16px",
  flexShrink: 0,
}));

const BackButton = styled(Button, {
  label: "MSHatBackButton",
})(() => ({
  color: "#fff",
  fontSize: "13px",
  fontWeight: "bold",
  textTransform: "none",
  minWidth: "auto",
  "&:hover": {
    backgroundColor: "rgba(255, 255, 255, 0.08)",
  },
}));

export const Header = ({
  onExit,
  centerContent,
  headerActions,
}: HeaderProps) => {
  return (
    <HeaderContainer>
      <BackButton
        onClick={onExit}
        startIcon={<BackArrowIcon width={24} height={24} color="#fff" />}
      >
        Back
      </BackButton>

      {centerContent && (
        <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
          {centerContent}
        </Box>
      )}

      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {headerActions}
      </Box>
    </HeaderContainer>
  );
};
